// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.numericInputFlex_M3lrY {
  width: 280px;
}

.numericInputLabel_ONx8Y {
  font-weight: 600 !important;
  font-size: 13px !important;
  line-height: 20px !important;
  color: var( --color-base700 ) !important;
}

.toggleLabel_A3R6v {
  font-weight: 400 !important;
  font-size: 13px !important;
  line-height: 20px !important;
  color: var( --color-base700 ) !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/alerts/editor/atomicEditors/Shared.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;AAC1C","sourcesContent":[".numericInputFlex {\n  width: 280px;\n}\n\n.numericInputLabel {\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  line-height: 20px !important;\n  color: var( --color-base700 ) !important;\n}\n\n.toggleLabel {\n  font-weight: 400 !important;\n  font-size: 13px !important;\n  line-height: 20px !important;\n  color: var( --color-base700 ) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numericInputFlex": `numericInputFlex_M3lrY`,
	"numericInputLabel": `numericInputLabel_ONx8Y`,
	"toggleLabel": `toggleLabel_A3R6v`
};
export default ___CSS_LOADER_EXPORT___;
